module.exports = __webpack_public_path__ + "img/sp4.96bbb0d8.svg";